import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // baseUrl: "http://xxm.gdeia.com"
        baseUrl: "https://official.mengyangkeji.cn"

    },
    mutations: {},
    actions: {},
    modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js